import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-refer-a-friend-success-page',
  templateUrl: './refer-a-friend-success-page.component.html',
  styleUrls: ['./refer-a-friend-success-page.component.scss']
})
export class ReferAFriendSuccessPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
